import { Col } from "react-bootstrap";

import { buildTestId } from "../../../../../shared";

const InsightCard = ({ title, value, description }) => {
  // Generate test ID from title
  const valueTestId = buildTestId("key-insight", title, "value");
  const descriptionTestId = buildTestId("key-insight", title, "description");

  return (
    <Col xs={12} sm={6} lg={3}>
      <div className="card h-100 shadow-sm insights-card p-1">
        <div className="card-body">
          <p className="card-text text-secondary small loose-text space-mono-text text-uppercase">
            {title}
          </p>
          <h2
            className="card-title mb-2 text-primary fw-bolder space-mono-text"
            data-testid={valueTestId}
          >
            {value}
          </h2>
          <p
            className="card-text text-secondary small"
            data-testid={descriptionTestId}
          >
            {description}
          </p>
        </div>
      </div>
    </Col>
  );
};

export default InsightCard;
